var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStorePostOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Post_Office",
    "data-name": "Post Office",
    transform: "translate(122.001 959.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__prefix__g4101",
    transform: "translate(-122.001 -959.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path336",
    d: "M-307.193-2061.887c0-6.628 7.165-12 16-12s16 5.372 16 12-7.163 12-16 12-16-5.372-16-12",
    transform: "translate(307.193 2073.887)",
    style: {
      fill: "#e51636"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path340",
    d: "M-127.423-1958.286a2.65 2.65 0 0 1 .768-1.917 2.65 2.65 0 0 1 1.911-.783 2.576 2.576 0 0 1 1.576.443v.732a2.515 2.515 0 0 0-1.576-.467 1.831 1.831 0 0 0-1.391.571 1.83 1.83 0 0 0-.494 1.421 1.88 1.88 0 0 0 .512 1.4 1.88 1.88 0 0 0 1.373.587 2.442 2.442 0 0 0 1.576-.466v.734a2.586 2.586 0 0 1-1.576.44 2.612 2.612 0 0 1-1.922-.771 2.613 2.613 0 0 1-.757-1.928",
    className: "prefix__cls-2",
    transform: "translate(146.598 1973.038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path344",
    d: "M-79.406-1959.76v5.142h3.467v-.71h-2.717v-1.566h2.365v-.709h-2.365v-1.45h2.59v-.708z",
    className: "prefix__cls-2",
    transform: "translate(103.703 1971.942)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path346",
    d: "M-142.553-1954.62h.751v-5.142h-.751z",
    className: "prefix__cls-2",
    transform: "translate(160.115 1971.944)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path350",
    d: "M-218.049-1959.76v5.142h.751v-2.2h2.2v-.709h-2.2v-1.529h2.458v-.708z",
    className: "prefix__cls-2",
    transform: "translate(227.558 1971.942)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path354",
    d: "M-274.4-1958.286a1.876 1.876 0 0 1 .509-1.4 1.876 1.876 0 0 1 1.374-.587 1.873 1.873 0 0 1 1.373.587 1.874 1.874 0 0 1 .508 1.405 1.873 1.873 0 0 1-.508 1.4 1.873 1.873 0 0 1-1.373.587 1.876 1.876 0 0 1-1.374-.587 1.875 1.875 0 0 1-.509-1.4m-.794 0a2.63 2.63 0 0 0 .761 1.922 2.63 2.63 0 0 0 1.916.778 2.63 2.63 0 0 0 1.915-.778 2.63 2.63 0 0 0 .761-1.922 2.631 2.631 0 0 0-.762-1.922 2.631 2.631 0 0 0-1.915-.778 2.63 2.63 0 0 0-1.916.778 2.63 2.63 0 0 0-.761 1.922",
    className: "prefix__cls-2",
    transform: "translate(278.608 1973.038)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path358",
    d: "M-180.48-1959.76v5.142h.752v-2.2h2.194v-.709h-2.194v-1.529h2.459v-.708z",
    className: "prefix__cls-2",
    transform: "translate(193.996 1971.942)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path362",
    d: "M-140.849-2022.484c0 1.143.8 1.381 1.517 1.607.526.168 1.028.343 1.028.829 0 .511-.553.769-1.028.776a2.6 2.6 0 0 1-1.43-.509v.752a2.247 2.247 0 0 0 1.413.494 1.673 1.673 0 0 0 1.256-.408 1.672 1.672 0 0 0 .569-1.192c0-1.018-.8-1.234-1.469-1.44-.572-.175-1.087-.343-1.087-.906 0-.275.226-.743.98-.743a1.925 1.925 0 0 1 1.174.37l.051.035v-.754a2.026 2.026 0 0 0-1.227-.36 1.577 1.577 0 0 0-1.184.353 1.577 1.577 0 0 0-.567 1.1",
    className: "prefix__cls-2",
    transform: "translate(158.592 2029.267)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path366",
    d: "M-107.02-2022.723v.709h1.634v4.432h.75v-4.432H-103v-.709z",
    className: "prefix__cls-2",
    transform: "translate(128.372 2028.184)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path370",
    d: "M-195.192-2021.231a1.877 1.877 0 0 1 .509-1.4 1.877 1.877 0 0 1 1.374-.588 1.876 1.876 0 0 1 1.374.587 1.876 1.876 0 0 1 .509 1.4 1.876 1.876 0 0 1-.509 1.4 1.876 1.876 0 0 1-1.374.587 1.876 1.876 0 0 1-1.374-.587 1.877 1.877 0 0 1-.509-1.4m-.794 0a2.631 2.631 0 0 0 .762 1.922 2.631 2.631 0 0 0 1.915.778 2.63 2.63 0 0 0 1.915-.778 2.63 2.63 0 0 0 .761-1.922 2.629 2.629 0 0 0-.761-1.922 2.629 2.629 0 0 0-1.915-.778 2.629 2.629 0 0 0-1.916.778 2.63 2.63 0 0 0-.761 1.922",
    className: "prefix__cls-2",
    transform: "translate(207.848 2029.263)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__path374",
    d: "M-230.513-2022.059c.4 0 1.057.113 1.057.863s-.661.862-1.057.862h-.946v-1.725zm-1.7-.665v5.141h.752v-2.085h1.064a1.468 1.468 0 0 0 1.188-.375 1.468 1.468 0 0 0 .472-1.154 1.468 1.468 0 0 0-.472-1.153 1.468 1.468 0 0 0-1.188-.375h-1.816",
    className: "prefix__cls-2",
    transform: "translate(240.209 2028.184)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStorePostOffice);
export default __webpack_public_path__ + "static/media/logo-store-post-office.76735b81.svg";
export { ForwardRef as ReactComponent };